export default __webpack_public_path__ + "static/media/clock.364669ef.gif";